import MultiInput from './MultiInput';

export default MultiInput;
